import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@cotyorg/ccx-molecules/Modal';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import FilterModalContents from '../FilterModalContents';

const modalID = uuid();

const FilterModal = ({
  categoryToggleTitle = '',
  categoryToggleProductText = '',
  modalHeadingText = '',
  filteredProducts = [],
  categories = [],
  selectedFilters = [],
  toggleFilter,
  setSelectedFilters,
  accordionMinusIconSrc,
  accordionPlusIconSrc,
  closeModal,
  refineIconSrc,
  modalCloseIconSrc,
  clearAllText,
  modalFormButtonText,
  dataTestApply,
  dataTestClearAll,
  isOpen,
  modalTriggerButtonWidth,
  modalTriggerButtonHeight,
}) => (
  <Modal
    id={modalID}
    triggerComponent={(
      <IconButton
        extraClass="filter__modal-trigger-button grid-x align-justify align-middle"
        iconSrc={refineIconSrc}
        iconAfterText
        iconExtraClass="filter__modal-trigger-icon"
        iconWidth={modalTriggerButtonWidth}
        iconHeight={modalTriggerButtonHeight}
      >
        <span className="filter__modal-trigger-title">
          {`${categoryToggleTitle}: `}
        </span>
        {`${filteredProducts.length} ${categoryToggleProductText}`}
      </IconButton>
    )}
    contentLabel={modalHeadingText}
    appElementSelector="#rsg-root"
    transition="slide"
    showCloseButton={false}
    modalContentExtraClass="filter__modal"
    modalContentInnerExtraClass="flex-column filter__modal-inner"
    hasGrid={false}
  >
    <FilterModalContents
      closeModal={() => closeModal(modalID)}
      categories={categories}
      toggleFilter={toggleFilter}
      selectedFilters={selectedFilters}
      setSelectedFilters={setSelectedFilters}
      accordionMinusIconSrc={accordionMinusIconSrc}
      accordionPlusIconSrc={accordionPlusIconSrc}
      modalHeadingText={modalHeadingText}
      modalCloseIconSrc={modalCloseIconSrc}
      clearAllText={clearAllText}
      modalFormButtonText={modalFormButtonText}
      dataTestClearAll={dataTestClearAll}
      dataTestApply={dataTestApply}
      isOpen={isOpen}
    />
  </Modal>
);

FilterModal.propTypes = {
  categoryToggleTitle: PropTypes.string.isRequired,
  categoryToggleProductText: PropTypes.string.isRequired,
  modalHeadingText: PropTypes.string.isRequired,
  filteredProducts: PropTypes.arrayOf(PropTypes.any).isRequired,
  categories: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedFilters: PropTypes.arrayOf(PropTypes.any).isRequired,
  toggleFilter: PropTypes.func.isRequired,
  setSelectedFilters: PropTypes.func.isRequired,
  accordionMinusIconSrc: PropTypes.string.isRequired,
  accordionPlusIconSrc: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  refineIconSrc: PropTypes.string.isRequired,
  modalCloseIconSrc: PropTypes.string.isRequired,
  clearAllText: PropTypes.string.isRequired,
  modalFormButtonText: PropTypes.string.isRequired,
  dataTestApply: PropTypes.string,
  dataTestClearAll: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  modalTriggerButtonWidth: PropTypes.number,
  modalTriggerButtonHeight: PropTypes.number,
};

export default FilterModal;
